<template>
  <div
    v-if="innerShow"
    class="overlay"
    :class="{ 'hide-overlay': hideOverlay, 'show-alert': innerShow }"
  >
    <div class="alert">
      <div class="text">
        <span v-html="message"></span>
      </div>
      <div class="buttons">
        <div v-if="!singleButton" class="cancel" @click="closeAlert">
          {{ cancelText }}
        </div>
        <div class="confirm" :style="{ '--color': color }" @click="doAction">
          {{ confirmText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'Alert',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    action: {
      type: Function,
      default: () => {},
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    singleButton: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: '確定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
  },
  emits: ['update:show'],
  setup(props, { emit }) {
    const store = useStore();
    const color = computed(() => store.getters.getColor(1));

    const innerShow = computed(() => props.show);
    const closeAlert = () => {
      emit('update:show', false);
    };

    const doAction = () => {
      closeAlert();
      props.action();
    };

    return {
      innerShow,
      color,
      doAction,
      closeAlert,
    };
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  z-index: -1;
  transition: 300ms;

  &.hide-overlay {
    background: #00000000;
    z-index: -1;
  }

  &.show-alert {
    z-index: 1150;
    background: #00000066;
    .alert {
      z-index: 1050;
      top: 50%;
      opacity: 1;
    }
  }

  .alert {
    display: flex;
    transition: 300ms;
    opacity: 0;
    z-index: -1;
    position: absolute;
    top: 51%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100vw - 48px);
    max-width: 327px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
    align-items: center;
    flex-direction: column;

    .text {
      width: 100%;
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      text-align: center;
      color: #333333;
      display: flex;
      justify-content: center;
      padding: 24px;
      box-sizing: border-box;
      border-bottom: solid 1px rgba(51, 51, 51, 0.2);
    }

    .buttons {
      width: 100%;
      height: 44px;
      display: flex;
      justify-content: center;
      .cancel,
      .confirm {
        width: 50%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.3px;
      }
      .cancel {
        color: #bdbdbd;
        border-right: solid 1px rgba(51, 51, 51, 0.2);
      }
      .confirm {
        color: var(--color);
      }
    }
  }
}
</style>
